import OrganizationAddPage from './OrganizationAddPage';

export default OrganizationAddPage;
